module.exports = __webpack_public_path__ + "media/images/brands/logo_energie_schweiz-59bc36f6a0609df13b3b0fd3ef444830.svg";